// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"0057e73c","143":"757afd87","191":"5370ff24","216":"ad615d34","253":"757afd87","364":"9efdba73","655":"9efdba73","774":"29ecb7dd","781":"356f6f30","828":"757afd87","838":"a20bba17"}[chunkId] + ".chunk.css";
};